import { type FC, type ReactNode } from "react";

import { clsx } from "clsx";

import { faFile } from "@fortawesome/pro-duotone-svg-icons/faFile";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { PANE_BACKGROUND, type PaneBackground } from "./review_pane";

// Over the report's pages: the file (or a file picker when there are several),
// and "Page X of N" on the right, following the scroll, then any actions.
export const ReportPagesBar: FC<{
  file: ReactNode;
  position?: ReactNode;
  actions?: ReactNode;
}> = ({ file, position, actions }) => (
  <div className="flex min-w-0 flex-1 items-center gap-2 border-b border-slate-200 bg-white px-4 py-2.5 text-[12.5px]">
    <FontAwesomeIcon icon={faFile} className="shrink-0 text-slate-400" />
    <span className="min-w-0 truncate font-semibold text-slate-700">
      {file}
    </span>
    {position && (
      <span className="ml-auto shrink-0 text-slate-500 tabular-nums">
        {position}
      </span>
    )}
    {actions && (
      <span
        className={clsx(
          "flex shrink-0 items-center gap-3",
          !position && "ml-auto",
        )}
      >
        {actions}
      </span>
    )}
  </div>
);

// The scrolling column of report pages.
export const ReportPagesColumn: FC<{
  children: ReactNode;
  hidden?: boolean;
  background?: PaneBackground;
  scrollRef?: React.Ref<HTMLDivElement>;
}> = ({ children, hidden, background = "slate-100", scrollRef }) => (
  <div
    ref={scrollRef}
    hidden={hidden}
    className={clsx(
      "flex min-h-0 min-w-0 flex-1 flex-col gap-5 overflow-y-auto rounded-lg border border-slate-200 p-4 [overflow-anchor:none]",
      PANE_BACKGROUND[background],
    )}
  >
    {children}
  </div>
);
